import React from "react";

interface Props {
  size?: number;
  color?: string;
}

export default function ChangeColor({ size = 20, color = "#79808A" }: Props) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.10934 2.74678L2.26522 8.59091C1.95533 8.90089 1.78125 9.32125 1.78125 9.75957C1.78125 10.1979 1.95533 10.6182 2.26522 10.9282L6.93986 15.6037C7.09338 15.7574 7.27568 15.8793 7.47635 15.9625C7.67702 16.0457 7.89212 16.0885 8.10934 16.0885C8.32657 16.0885 8.54167 16.0457 8.74234 15.9625C8.94301 15.8793 9.12531 15.7574 9.27883 15.6037L15.1221 9.75957L8.10934 2.74678ZM8.10934 2.74678L6.94068 1.57812"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.6201 12.4844C16.6201 12.4844 19.0996 14.9581 19.0996 16.5234C19.0996 17.8913 17.9879 19.0029 16.6201 19.0029C15.2514 19.0029 14.1505 17.8913 14.1406 16.5234C14.1489 14.9572 16.6201 12.4844 16.6201 12.4844Z"
        stroke={color}
        stroke-width="1.5"
        stroke-miterlimit="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
